import { EditorState } from 'draft-js';

/**
 * Find link entity of the current selection
 * @param {EditorState} editorState
 */
export function findLinkEntity(editorState) {
	const contentState = editorState.getCurrentContent();
	const startKey = editorState.getSelection().getStartKey();
	const startOffset = editorState.getSelection().getStartOffset();
	const blockWithLinkAtBeginning = contentState.getBlockForKey(startKey);

	try {
		const linkKey = blockWithLinkAtBeginning.getEntityAt(startOffset);
		return linkKey ? contentState.getEntity(linkKey) : null;
	} catch (err) {
		return null;
	}
}


// WEBPACK FOOTER //
// ./lib/helpers/findLinkEntity.js